import { apiGet } from './api';

export const getUserById = async (id: any) => {
  const params = {
    action: 'get_user_by_id',
    id,
  };
  const { data } = await apiGet(params);
  return data;
};

export const getMerchantById = async (id: any) => {
  const params = {
    action: 'get_merchant_by_id',
    id,
  };
  const { data } = await apiGet(params);
  return data;
};

export const getUserByPhone = async (phone: any) => {
  const params = {
    action: 'get_user_by_phone',
    phone,
  };
  const { data } = await apiGet(params);
  return data;
};
